import React, { isValidElement, ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { Alert, AlertTitle } from '@mui/material';
import { PayerError } from '../utils/errors';
import { PayerErrorMessage } from './PayerErrorMessage';

const errorAlertSx = {
  marginBottom: '1rem',
  minWidth: '0',
  '& .MuiAlert-message': {
    minWidth: '0',
    overflowWrap: 'break-word',
  },
};

export type ErrorNotificationProps = {
  children: ReactNode | PayerError;
};

export const ErrorNotification = ({ children }: ErrorNotificationProps) => {
  const errorComponent = isValidElement(children) ? children : <PayerErrorMessage error={children as PayerError} />;

  return (
    <Alert severity="error" sx={errorAlertSx}>
      <AlertTitle>
        <Trans i18nKey="error.error" />
      </AlertTitle>
      {errorComponent}
    </Alert>
  );
};
